/** PhaseBanner — small ops strip shown on admin pages so operators always
 *  know whether the platform is currently publishing modelled figures or is
 *  running in Phase 1 digital-only mode. Non-mutating, read-only.
 *
 *  Fetches GET /api/public/phase (no auth required — the phase status is
 *  public info; the flag itself is not user-settable via API). */
import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TONE_STYLES = {
  warning: { bg: "#F59E0B22", border: "#F59E0B77", accent: "#FCD34D", body: "#FDE68A" },
  success: { bg: "#10B98122", border: "#10B98177", accent: "#6EE7B7", body: "#A7F3D0" },
  neutral: { bg: "#64748B22", border: "#64748B77", accent: "#CBD5E1", body: "#E2E8F0" },
};

export function PhaseBanner() {
  const [phase, setPhase] = useState(null);
  useEffect(() => {
    axios.get(`${API_BASE}/public/phase`).then((r) => setPhase(r.data)).catch(() => {});
  }, []);
  if (!phase) return null;
  const s = TONE_STYLES[phase.tone] || TONE_STYLES.neutral;
  return (
    <div data-testid="phase-banner" role="status" aria-live="polite" style={{
      display: "flex", gap: 14, alignItems: "flex-start",
      padding: "12px 16px", marginBottom: 20,
      background: s.bg, border: `1px solid ${s.border}`, borderRadius: 8,
      fontSize: 12, lineHeight: 1.55,
    }}>
      <span aria-hidden="true" style={{ color: s.accent, fontSize: 18, marginTop: -2 }}>
        {phase.phase_label === "phase1" ? "⏳" : "✓"}
      </span>
      <div>
        <div data-testid="phase-banner-text" style={{ fontWeight: 700, color: s.accent, marginBottom: 2 }}>
          {phase.text}
        </div>
        <div style={{ color: s.body }}>{phase.detail}</div>
      </div>
    </div>
  );
}
